import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'reactstrap';
import ReactLoading from 'react-loading';
import { textValue, checkChange } from '../../../../utils/form';
import { updateSale, doMarkedSale, getSaleNotes, setReadSaleNotes, getDetailSale2, getTrackingShipmentDetail } from '../../../../actions/saleAction';
import { TextRupiah } from '../../../../components/Text';
import { Th } from '../../../../components/Tbl';
import { FontAwesomeIcon } from '../../../../components/Icons';
import DateToHuman from '../../../../components/DateToHuman';
import OrderColumn from './rowItem/OrderColumn';
import { getPaymentType, getPaymentVia } from '../../../../constants/kickavenue';
import { ModalMarkedSale, ModalTrackingShipment } from '../../../../components/Modals';
import SmallInline from '../../../../styled/Typograph/Small/SmallInline';
import ButtonStarred from '../../RowItem/ButtonStarred';
import Compensation from '../../RowItem/Compensation';

class RowItem extends React.Component{
  constructor(props){
    super(props);
    this.state={
      autoDisburse: props.autoDisburse,
      _autoDisburseEdit: props.autoDisburse,
      updatedAt: props.updatedAt,
      marked: props.marked,
      _markedEdit: props.marked,
      markedAt: props.markedAt || '',
      markedBy: props.markedBy || '',
      closeMarkedAt: props.closeMarkedAt || '',
      closeMarkedBy: props.closeMarkedBy || '',
      notes: props.notes || [],
      notesPage: 1,
      noteNextPage: null,
      unreadNoteCount: props.unreadNoteCount || 0,
      isConfirmation: false,
      purchasePrice: props.purchasePrice,
      compensation: props.compensation,
      followUpStatus: props.followUpStatus,
      _isModalTracking: false,
      shippingUpdate: null
    }
    this._handleCheckedChange = this._handleCheckedChange.bind(this);
    this._handleMarkedChange = this._handleMarkedChange.bind(this);
    this._handleTrackingChange = this._handleTrackingChange.bind(this);
    this._handleModalMarkedOnSubmit = this._handleModalMarkedOnSubmit.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if(!_.isEqual(prevProps.dataItem, this.props.dataItem)){
      this.setState({
        autoDisburse: this.props.autoDisburse,
        _autoDisburseEdit: this.props.autoDisburse,
        updatedAt: this.props.updatedAt,
        marked: this.props.marked,
        _markedEdit: this.props.marked,
        // markedNotes: this.props.markedNotes || '',
        markedAt: this.props.markedAt || ''
      })
    }
    if(prevProps.sale.followUpSales.isSubmit !== this.props.sale.followUpSales.isSubmit && !this.props.sale.followUpSales.isSubmit){
      const { error, followUp } = this.props.sale.followUpSales;
      if(!error && prevProps.id === followUp.id){
        this.setState({
          updatedAt: followUp.updated_at,
          compensation: followUp.compensation_amount,
          followUpStatus: followUp.follow_up_status
        })
      } else if(error && prevProps.id === followUp.id){
        alert("Error when processing follow-up sales.")
      }
    }
    if(prevProps.sale.isSubmit !== this.props.sale.isSubmit && prevProps.sale.isSubmit){
      if(prevProps.sale.error===null){
        const { id, autodisburse, updated_at, marked, open_marked_at, open_marked_by, sale_notes, unread_notes_count, close_marked_at, close_marked_by, purchase_price } = this.props.sale.detail;
        if(prevProps.id===id){
          this.setState({
            autoDisburse: autodisburse,
            _autoDisburseEdit: autodisburse,
            marked: marked,
            _markedEdit: marked,
            // markedNotes: marked_notes || '',
            markedAt: open_marked_at || '',
            markedBy: open_marked_by || '',
            closeMarkedAt: close_marked_at || '',
            closeMarkedBy: close_marked_by || '',
            // notes: sale_notes,
            // unreadNoteCount: unread_notes_count,
            updatedAt: updated_at,
            purchasePrice: purchase_price
          })
        }
      }
      else{
        const { id } = this.props.sale.error;
        if(id && this.props.id === id){
          this.setState({
            _autoDisburseEdit: this.state.autoDisburse,
            _markedEdit: this.state.marked,
          })
        }
      }
    }

    if(prevProps.sale.notes.isFetch && !this.props.sale.notes.isFetch){
      const { list: { data, next_page_url, error }, saleId } = this.props.sale.notes;
      if(this.props.id === saleId){
        if(error) {
          alert('Error while fetching notes');
        } else{
          const { loginId } = this.props;
          const ids = data.filter(item => !item.read && item.user_id !== loginId).map(({ id }) => id);
          if(ids.length){
            this.props.setReadSaleNotes(this.props.id, { ids })
          }
          this.setState({
            notes: this.state.notesPage === 1? [...data]: [...data, ...this.state.notes],
            noteNextPage: next_page_url? this.state.notesPage + 1: null
          })
        }
      }
    }

    if(prevProps.sale.saleDetail.isFetch && !this.props.sale.saleDetail.isFetch){
      const { error, data } = this.props.sale.saleDetail;
      if(!error && data.id === this.props.id){
        const { unread_notes_count } = data;
        this.setState({
          unreadNoteCount: unread_notes_count
        });
      }
    }

    if(prevProps.sale.notes.isSubmit && !this.props.sale.notes.isSubmit){
      const { readNotes: { data }, saleId, error } = this.props.sale.notes;
      if(this.props.id === saleId && !error){
        if(data.total > 0) {
          this.props.getDetailSale2(this.props.id);
        }
      }
    }
    if(!prevState._isModalMarked && this.state._isModalMarked){
      this.setState({
        notesPage: 1,
        noteNextPage: null
      }, () => {
        this.props.getSaleNotes(this.props.id, {
          params: { per_page: 3, page: this.state.notesPage }
        });
      })
    }
    if (!prevState._isModalTracking && this.state._isModalTracking) {
      this.props.getTracking(this.props.id)
    }
    if (prevProps.sale.shippingUpdate.isFetch && !this.props.sale.shippingUpdate.isFetch)
    {
      const { data, error } = this.props.sale.shippingUpdate;
      if (!error) {
        this.setState({
          shippingUpdate: data
        })
      }
    }
  }

  shouldComponentUpdate(nextProps){
    if(nextProps.sale.isSubmit){
      return false;
    }
    if(!nextProps.sale.isSubmit&&nextProps.sale.isSubmit!==this.props.sale.isSubmit){
      if(nextProps.sale.error){
        const { error: { id } } = nextProps.sale;
        if(id && id != this.props.id){
          return false;
        }
      }
      else{
        if(nextProps.sale.detail.id && nextProps.sale.detail.id != this.props.id){
          return false;
        }
      }
    }
    // if(nextProps.isSelected == this.props.isSelected) return false;
    // else{
    //   if(nextProps.isSelected!=this.props.isSelected||!_.isEqual(nextProps.dataItem, this.props.dataItem)){
    //     //commented because defaultnya true
    //     return true;
    //   }
    // }
    return (nextProps.selectedId === null && nextProps.selectedId === this.props.selectedId)
    || (nextProps.selectedId === null && this.props.selectedId === this.props.id)
    || nextProps.selectedId === this.props.id;
  }

  _handleTrackingChange(){
    this.setState({
      _isModalTracking: !this.state._isModalTracking,
    });
  }

  _handleCheckedChange(e) {
    this.setState({
      ...checkChange(e, this.state)
    }, ()=>{
      const payload = {
      autodisburse : this.state._autoDisburseEdit
      }
      this.props.update(this.props.id, payload)
    });
  }

  _handleModalMarkedOnSubmit({ marked_notes, marked = null }){
    if(marked === false){
      const payload = { marked };
      if(marked_notes){
        payload['marked_notes'] = marked_notes;
      }
      this.setState({
        _markedEdit : marked,
        _isModalMarked: false,
        // isConfirmation: false
      });
      this.props.doMarkedSale(this.props.id, payload)
      return;
    }
    this.setState({
      _markedEdit : this.state.closeMarkedAt? (marked !== null? marked: this.state._markedEdit): true,
      _isModalMarked: false,
      // isConfirmation: false,
      markedNotes: marked_notes
    }, () => {
      const payload = {
        // status : param.status,
        marked : this.state._markedEdit,
        marked_notes
      }
      this.props.doMarkedSale(this.props.id, payload)
    })
  }

  _handleMarkedChange(){
    this.setState({
      // isConfirmation: false,
      _isModalMarked: !this.state._isModalMarked,
      _markedEdit : this.state.marked //cancel toggle
    });
  }

  _openPurchasePriceModal = e => {
    e.preventDefault();
    this.props.openPurchasePriceModal({
      id: this.props.id,
      invoiceNumber: this.props.invoiceNumber,
      purchasePrice: this.state.purchasePrice
    })
  }

  _openFollowUpModal = e => {
    e.preventDefault();
    const status = this.state.followUpStatus? this.state.followUpStatus: 'SET_FOLLOW'
    this.props.openFollowUpModal({
      id: this.props.id,
      invoiceNumber: this.props.invoiceNumber,
      compensation: this.state.compensation,
      status,
      user: this.props.buyerEmail,
      seller: this.props.sellerEmail
    })
  }


  render(){
    const {
      id,
      dataItem,
      number,
      quantity,
      buyerEmail,
      invoiceNumber,
      totalPrice,
      orderDate,
      // updatedAt,
      displayName,
      SKU,
      size,
      colour,
      preOrder,
      preVerified,
      sneakersCondition,
      kaCourier,
      awbNumber,
      sellerId,
      sellerEmail,
      status,
      consignmentId,
      category,
      bank,
      paymentVia,
      paymentMethod,
      rack,
      moneyDisbursed,
      voucherCode,
      legitCheckLogs
      // markedAt,
      // markedNotes
    } = this.props;
    // console.log('staeeee', this.state.markedNotes)
    const via = getPaymentVia(paymentVia);
    const canFollowup = this.state.followUpStatus === null || this.state.followUpStatus === 'PENDING';

    const courierOptionValue =
      dataItem && dataItem.offer ? dataItem.offer.ka_courier_option : null;
    const addOnValue =
      courierOptionValue &&
      courierOptionValue !== 'WAREHOUSE' &&
      courierOptionValue !== 'FLAT_RATE'
        ? courierOptionValue
        : null;
    return(
      <tr>
        <ModalMarkedSale
          isOpen={this.state._isModalMarked}
          isConfirmation={this.state.isConfirmation}
          toggle={this._handleMarkedChange}
          invoiceNumber={invoiceNumber}
          marked={this.state.marked}
          markedAt={this.state.markedAt}
          markedBy={this.state.markedBy}
          closeMarkedAt={this.state.closeMarkedAt}
          markedNotes={this.state.markedNotes}
          notes={this.state.notes}
          unreadNoteCount={this.state.unreadNoteCount}
          hasNextPage={this.state.noteNextPage}
          loginId={this.props.loginId}
          onSubmit={this._handleModalMarkedOnSubmit}
          onLoadMoreNotes={() => {
            const { notesPage, noteNextPage } = this.state;
            if(!noteNextPage) return;
            this.setState({
              noteNextPage: null,
              notesPage: notesPage + 1
            }, () => {
              this.props.getSaleNotes(this.props.id, {
                params: { per_page: 3, page: this.state.notesPage }
              });
            })
          }}
        />
        <ModalTrackingShipment
          shippingUpdate={this.state.shippingUpdate}
          isLoading={this.props.sale.shippingUpdate.isFetch}
          isOpen={this.state._isModalTracking}
          toggle={this._handleTrackingChange}
        />
        <Th className="v-center" scope="row">{ number }</Th>
        <td className="v-center">
          <OrderColumn
            id={id}
            quantity={quantity}
            buyerEmail={buyerEmail}
            invoiceNumber={invoiceNumber}
            orderDate={orderDate}
            displayName={displayName}
            SKU={SKU}
            size={size}
            colour={colour}
            preOrder={preOrder}
            preVerified={preVerified}
            status={status}
            sneakersCondition={sneakersCondition}
            consignmentId={consignmentId}
            category={category}
            marked={this.state._markedEdit}
            unreadNoteCount={this.state.unreadNoteCount}
            legitCheckLogs={legitCheckLogs}
            addOn={addOnValue}
            printedBy={dataItem.printed_by_email || dataItem.printed_by}
            printedAt={dataItem.printed_at}
            // onMarkToggle={value => {
            //   if(!value){
            //     this.setState({
            //       _markedEdit: value
            //     })
            //     this.props.doMarkedSale(this.props.id, { marked: value })

            //   }else {
            //     this.setState({
            //       _isModalMarked: true,
            //       _markedEdit: value
            //     })
            //   }
            // }}
          />
          <div>
            <p className="mb-0" style={{fontSize: '.75rem'}}>
              Purchase price: Rp. { this.state.purchasePrice? <TextRupiah tag="span" prefix="" value={this.state.purchasePrice}/>: '-' }
              <a
                href="#"
                className="ml-2"
                style={{textDecoration: 'underline', color: '#4a4a4a', fontSize: '.75rem'}}
                onClick={this._openPurchasePriceModal}
              >
                <i className="fa fa-pencil"></i> edit
              </a>
            </p>
          </div>
        </td>
        {/* <td className="v-center">
          <div>
            <label className="switch switch-text switch-success-outline-alt">
              <input type="checkbox"
                className="switch-input"
                name="_autoDisburseEdit"
                id="formSaleAutoDisburse"
                value="true"
                checked={textValue('_autoDisburseEdit', this.state)}
                onChange={this._handleCheckedChange}
              />
              <span className="switch-label" data-on="YES" data-off="NO"></span>
              <span className="switch-handle"></span>
            </label>
          </div>
          {rack && (
            <span className="text-uppercase rack-span" style={{fontSize: '.75rem'}}>
              RACK: {rack}
            </span>
          )}
        </td> */}
        <td className="v-center">
          <div className="text-uppercase">
            <Badge color="primary"><FontAwesomeIcon iconType="truck"/> { kaCourier }</Badge>
          </div>
          { awbNumber }
          <div>
            <Button
              onClick={this.props.onOpenAwbNumberModal}
              className="btn-link btn-sm link-secondary"
              style={{textDecoration:'underline', fontSize: '0.75rem'}}
            >
              <FontAwesomeIcon iconType="pencil"/> Edit Awb Number
            </Button>
          </div>
          <div>
            <SmallInline>Auto Disburse</SmallInline><br/>
            <label className="switch switch-text switch-success-outline-alt">
              <input type="checkbox"
                className="switch-input"
                name="_autoDisburseEdit"
                id="formSaleAutoDisburse"
                value="true"
                checked={textValue('_autoDisburseEdit', this.state)}
                onChange={this._handleCheckedChange}
              />
              <span className="switch-label" data-on="YES" data-off="NO"></span>
              <span className="switch-handle"></span>
            </label>
          </div>
        </td>
        <td className="v-center">
          <TextRupiah prefix="Rp. " value={totalPrice}/>
          {
            voucherCode && (
              <div className="text-uppercase voucher-wrapper" style={{fontSize: '.5rem'}}>
                <FontAwesomeIcon iconType="ticket"/> {voucherCode}
              </div>
            )
          }
          <div className="issued-wrapper" style={{minWidth: 95}}>
            <a
              href="#"
              className="mr-1"
              style={{textDecoration: 'underline', color: '#4a4a4a', fontSize: '.75rem'}}
              onClick={e => {
                e.preventDefault();
                this.setState({ _isModalMarked: true })
              }}
            >
              <i className="fa fa-pencil"></i> {this.state.markedAt? 'view': 'add'} notes
              {/* <i className="fa fa-pencil"></i> add notes */}
            </a>
            <ButtonStarred
              title={this.state._markedEdit? "Remove mark!": "Mark!"}
              value={this.state._markedEdit}
              onClick={() => {
                const value = !this.state._markedEdit;
                this.setState({
                  _isModalMarked: true,
                  isConfirmation: !value,
                  _markedEdit: value
                })
              }}
            />
          </div>
          <div>
            <p style={{marginBottom: 0}}>
              <span style={{fontSize: '.5rem'}}>SOLD BY</span><br/>
              <Link
                to={`/users/${sellerId}`}
                title="More detail..."
                style={{textDecoration: 'underline'}}
                className="link link-secondary"
              >
                {sellerEmail}
              </Link>
            </p>
          </div>
        </td>
        <td className="v-center">
          <a 
            href="#"
            className="mr-1"
            style={{textDecoration: 'underline', color: '#4a4a4a', fontSize: '.75rem'}}
            onClick={e => {
              e.preventDefault()
              this.setState({
                _isModalTracking: true,
                shippingUpdate: null
              })
            }}
          >Tracking Shipment</a><br />
          <div>
            {
              bank && paymentMethod === 'virtual_account'?
              <span style={{fontSize: '.75rem'}}>{bank+ '-'+ getPaymentType(paymentMethod)}</span>
              :
              getPaymentType(paymentMethod)
            }
          </div>
          { via !== null? <div><span style={{fontSize: '.75rem'}}>via <i>{via}</i></span></div>: null}
          {
            paymentVia !== null && paymentVia === 'vt' && paymentMethod=== "credit_card" ?
            <button className="btn btn-sm btn-secondary" onClick={this.props.onOpenCreditCard} target="_blank" title="Show More Info"><i className="fa fa-info-circle"></i> More Info</button>
            :
            null
          }
          {
            <div><span style={{fontSize: '.75rem'}}>{dataItem.offer.payment_id?dataItem.offer.payment_id:dataItem.offer.id}</span></div>
          }
        </td>
        <td className="v-center"><DateToHuman  value={this.state.updatedAt} id={`tooltip_processedList_updatedAt_rowItem_${number}`}/></td>
        <td className="v-center">
          {
            this.props.showActionLoading?
            <ReactLoading
              type="bars"
              color="green"
              height={20}
              width={30}
            />
            :
            <div>
              <Compensation
                showButton={canFollowup && moneyDisbursed === null}
                compensation={this.state.compensation}
                status={this.state.followUpStatus}
                onFollowUpClick={this._openFollowUpModal}
              />
              {this.props.renderActionButton && this.props.renderActionButton()}
            </div>
          }
          <div>
            {/* <SmallInline>Marked Sale</SmallInline><br />
            <label className="switch switch-text switch-success-outline-alt">
              <input type="checkbox"
                className="switch-input"
                name="_markedEdit"
                id="formSaleMarked"
                value="true"
                checked={textValue('_markedEdit', this.state)}
                onChange={this._handleMarkedChange}
              />
              <span className="switch-label" data-on="YES" data-off="NO"></span>
              <span className="switch-handle"></span>
            </label> */}
          </div>
        </td>
      </tr>
    )
  }
}

const mapStateToProps = ({ sale }) => ({
  sale
})

const mapDispatchToProps = (dispatch) => ({
  getDetailSale2: (id) => dispatch(getDetailSale2(id)),
  getSaleNotes: (id, query) => dispatch(getSaleNotes(id, query)),
  setReadSaleNotes: (id, body) => dispatch(setReadSaleNotes(id, body)),
  update: (id, payload) => dispatch(updateSale(id, payload)),
  doMarkedSale: (id, payload) => dispatch(doMarkedSale(id, payload)),
  getTracking: id => dispatch(getTrackingShipmentDetail(id))
})

export default connect (mapStateToProps, mapDispatchToProps) (RowItem);

RowItem.propTypes = {
  dataItem: propTypes.object.isRequired,
  id: propTypes.number.isRequired,
  number: propTypes.number.isRequired,
  buyerEmail: propTypes.string,
  autoDisburse: propTypes.number,
  sellerId: propTypes.number,
  sellerEmail: propTypes.string,
  invoiceNumber: propTypes.string.isRequired,
  totalPrice: propTypes.string,
  orderDate: propTypes.string,
  kaSent: propTypes.string,
  awbNumber: propTypes.string,
  kaCourier: propTypes.string,
  displayName: propTypes.string,
  SKU: propTypes.string,
  size: propTypes.string,
  colour: propTypes.string,
  preOrder: propTypes.oneOfType([propTypes.number,  propTypes.bool]),
  preVerified: propTypes.oneOfType([propTypes.bool,  propTypes.bool]),
  sneakersCondition: propTypes.string,
  showActionLoading: propTypes.bool,
  onOpenAwbNumberModal: propTypes.func,
  renderActionButton: propTypes.func,
  consignmentId: propTypes.string,
  onOpenCreditCard: propTypes.func.isRequired,
  marked: propTypes.bool,
  status: propTypes.string,
  markedNotes: propTypes.string,
  markedAt: propTypes.string,
  rack: propTypes.string,
}

RowItem.defaultProps = {
  isSelected: false,
  preOrder: false,
  sneakersCondition: 'BARU'
}
